import { SvgWrapperProps } from './types';

const SvgWrapper = ({
  width,
  height,
  wrapperStyle,
  children
}: SvgWrapperProps) => {
  return (
    <div style={{ width, height, ...wrapperStyle }}>
      <svg width={width} height={height} viewBox={`0 0 30 30`}>
        {children}
      </svg>
    </div>
  );
};

export default SvgWrapper;
